import React from "react";

import "./ImgLeft.css";

const imgLeft = (props) => {
  return (
    <div className="row py-3">
      <div className="col-md-4 d-flex align-items-center justify-content-center">
        <img src={props.image} className="img-fluid" alt=""/>
      </div>
      <div className="col-md-8">
        <h3>
          {props.header}
        </h3>
        <div className="text-muted">
          {props.text}
        </div>
      </div>
    </div>
  );
};

export default imgLeft;



// WEBPACK FOOTER //
// ./src/components/UI/Section/ImgLeft/ImgLeft.js